export default "__VITE_ASSET__jh3kR6Nu__"